import * as React from "react";
import { Route, Switch } from "react-router";
import { ERoutes } from "../../../../AppRouter";
import { SuiviWalterDetailPage } from "./SuiviWalterDetailPage";
import { SuiviHopeDetailPage } from "./SuiviHopeDetailPage";

export interface ISuiviSwitchProps {}

export const SuiviSwitch: React.FunctionComponent<ISuiviSwitchProps> = props => {
  return (
    <Switch>
      <Route path={`${ERoutes.suivi}/:id/:tab/:state?/hope`} component={SuiviHopeDetailPage} />
      <Route path={`${ERoutes.suivi}/:id/:tab/:state?/walter`} component={SuiviWalterDetailPage} />
    </Switch>
  );
};

export default SuiviSwitch;
